import React from 'react';

const SampleRequest = ({ sampleObject }) => {
	if (!sampleObject) return null;

	const formatJson = (obj) => {
		const jsonStr = JSON.stringify(obj, null, 2);
		if (!jsonStr) return null;

		return jsonStr
			.split(/(\s*{\s*|\s*}\s*|\s*:\s*|\s*,\s*|\s*\[\s*|\s*\]\s*)/g)
			.map((str, i) => {
				if (/^"[^"]+":$/.test(str)) {
					return (
						<span key={i} className='text-yellow-300 text-sm'>
							{str}
						</span>
					);
				} else if (/^"\S.*"$/.test(str)) {
					return (
						<span key={i} className='text-yellow-300 text-sm'>
							{str}
						</span>
					);
				} else if (/^\d+$/.test(str)) {
					return (
						<span key={i} className='text-[#fdc137] text-sm'>
							{str}
						</span>
					);
				}
				return str;
			});
	};

	const { method, endpoint, host, contentType, body } = sampleObject;

	return (
		<div className='api-doc-sample-panel w-full h-full rounded-lg border border-gray-700 md:border-b-0 bg-[#2D3134] overflow-hidden'>
			<div className='flex items-center border-b border-gray-700 bg-[#242729] px-4 py-3'>
				<p className='rounded-md bg-[#fdc137] px-3 py-1 text-sm font-medium uppercase text-gray-900 m-0'>
					http
				</p>
			</div>

			<div className='w-full p-4 md:p-4'>
				<pre className='api-doc-sample-pre w-full overflow-x-auto rounded-md bg-[#272B2D] m-0 p-4 text-sm leading-6 text-gray-100'>
					<code className='block whitespace-pre'>
						<span className='text-green-400'>{method}</span> {endpoint} HTTP/1.1
						{'\n'}
						<span className='text-green-400 text-sm'>Host:</span>{' '}
						<span className='text-yellow-300 text-sm'>{host}</span>
						{'\n'}
						<span className='text-green-400 text-sm'>Content-Type:</span>{' '}
						<span className='text-yellow-300 text-sm'>{contentType}</span>
						{'\n\n'}
						{formatJson(body)}
					</code>
				</pre>
			</div>
		</div>
	);
};

export default SampleRequest;
